import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/** [ME-56819](https://masterysys.atlassian.net/browse/ME-56819) Enable Fullstory recording */
export const useFlagMe56819AppFullstoryEnable = (): boolean => useINTERNALFlag('ME-56819-app-fullstory-enable');
/** [ME-56819](https://masterysys.atlassian.net/browse/ME-56819) Enable Fullstory recording */
export const FlagMe56819AppFullstoryEnable = (props: PropsNoName) => <INTERNALFlag name="ME-56819-app-fullstory-enable" {...props}/>
